import apiClient from './apiClient';

export const getAllAnfragen = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.kundeId) params.append('kundeId', filters.kundeId);
  if (filters.status) params.append('status', filters.status);
  if (filters.kategorie) params.append('kategorie', filters.kategorie);

  const queryString = params.toString();
  const url = queryString ? `/anfragen?${queryString}` : '/anfragen';
  const response = await apiClient.get(url);
  return response.data;
};

export const getAnfrageById = async (id) => {
  const response = await apiClient.get(`/anfragen/${id}`);
  return response.data;
};

export const getOffeneAktionen = async () => {
  const response = await apiClient.get('/anfragen/offene-aktionen');
  return response.data;
};

export const getPoolByBearbeiter = async () => {
  const response = await apiClient.get('/anfragen/pool-by-bearbeiter');
  return response.data;
};

export const createAnfrage = async (anfrageData) => {
  const response = await apiClient.post('/anfragen', anfrageData);
  return response.data;
};

export const updateAnfrage = async (id, anfrageData) => {
  const response = await apiClient.put(`/anfragen/${id}`, anfrageData);
  return response.data;
};

export const updateAnfrageStatus = async (id, status) => {
  const response = await apiClient.put(`/anfragen/${id}`, { status });
  return response.data;
};

export const bulkUpdateAnfragen = async (ids, status) => {
  const response = await apiClient.put('/anfragen/bulk', { ids, status });
  return response.data;
};

export const zusammenfassungAnfrage = async (id) => {
  const response = await apiClient.post(`/anfragen/${id}/zusammenfassung`);
  return response.data;
};

export const deleteAnfrage = async (id) => {
  const response = await apiClient.delete(`/anfragen/${id}`);
  return response.data;
};

export const bulkDeleteAnfragen = async (ids) => {
  const response = await apiClient.delete('/anfragen/bulk', { data: { ids } });
  return response.data;
};
